// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  isOpen: boolean,
  onClose: () => void,
  i18nTitleKey?: string,
  title?: string,
  children: React.ReactNode,
}


class Modal extends React.PureComponent<Props> {
  render() {
    if (!this.props.isOpen) {
      return false;
    }
    return (
      <div role="presentation" className="modal-container" onClick={this.props.onClose}>
        <div role="presentation" onClick={event => event.stopPropagation()} className="modal">
          <div className="modal-title">
            <span />
            {
              this.props.i18nTitleKey
                ? <Translate value={this.props.i18nTitleKey} />
                : this.props.title
            }
            <button onClick={this.props.onClose} type="button">
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
